export const API_KEY = 'ff02321d';
